var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-modal',_vm._g(_vm._b({},'export-modal',_vm.modalProps,false),_vm.modalEvents))
}
var staticRenderFns = []

export { render, staticRenderFns }